import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./AppHeader.css";

const AppHeader = () => {
  const location = useLocation();
  const { authMode, isAuthenticated, signInWithMock, signOut, user } = useAuth();

  const navItems = [
    { to: "/", label: "検索" },
    { to: "/deck", label: "デッキ構築（β版）" },
  ];

  const isDeckRoute = location.pathname.startsWith("/deck");

  return (
    <header className="app-header">
      <div className="app-header-inner">
        <div className="app-header-main">
          <div className="app-brand">
            <Link to="/" className="app-brand-link">
              Gundam War Database
            </Link>
          </div>

          <nav className="app-nav" aria-label="Primary">
            {navItems.map((item) => {
              const isActive =
                item.to === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.to);

              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={isActive ? "app-nav-link active" : "app-nav-link"}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="app-auth">
          {isAuthenticated ? (
            <>
              <div className="app-auth-status">
                <span className="app-auth-label">ログイン中</span>
                <strong>{user.name}</strong>
              </div>
              <button className="app-auth-button" onClick={signOut}>
                ログアウト
              </button>
            </>
          ) : authMode === "mock" ? (
            <>
              <div className="app-auth-status">
                <span className="app-auth-label">ローカル環境</span>
                <strong>テストモード</strong>
              </div>
              <button className="app-auth-button" onClick={signInWithMock}>
                テストログイン
              </button>
            </>
          ) : (
            <>
              <div className="app-auth-status">
                <span className="app-auth-label">未ログイン</span>
                <strong>
                  {authMode === "google"
                    ? "デッキ構築でログイン"
                    : isDeckRoute
                      ? "ログイン設定を確認してください"
                      : "保存機能はログイン後に使えます"}
                </strong>
              </div>
              <Link className="app-auth-button" to="/deck">
                {authMode === "google" ? "ログイン" : "確認"}
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
